module.exports = __webpack_public_path__ + "static/media/meme-4.9d0f3f7a.webp";